import React from "react";
import SectionHeader from "./SectionHeader";
import PublicLeagueRow, { PANEL_BLEED } from "./PublicLeagueRow";
import CompletedLeagueTile from "./CompletedLeagueTile";
import LeagueEmptyState, { EmptyStateArt } from "./LeagueEmptyState";
import TileSkeleton from "./TileSkeleton";
import { getLeagueStatus } from "./leagueStatus";

// One rule for "this league is over", shared with the picker's bucketing so a
// league can't be sorted as finished and then drawn as if it were still running.
const isCompleted = (game) =>
  game?.status === "completed" || getLeagueStatus(game)?.tone === "ended";

// My Leagues. Narrow column on desktop, full width on mobile, so tiles stack —
// two-across only once there's room for it.
const MyLeaguesSection = ({ leagues, loading }) => {
  const list = Array.isArray(leagues) ? leagues.slice(0, 2) : [];

  return (
    // Anchored so other screens can send the user straight here — the payoff
    // after creating a league does. `scroll-mt` keeps the heading clear of the
    // fixed app header when it lands.
    <section id="my-leagues" className="scroll-mt-28">
      {/* "View all" only once there's something to see all of. */}
      <SectionHeader
        title="My Leagues"
        viewAllTo={list.length > 0 ? "/contest/my-games" : undefined}
      />

      {loading ? (
        <TileSkeleton />
      ) : list.length > 0 ? (
        <div className="space-y-3">
          {/* Active leagues take the slots first (leaguePicker's ordering). A
              running or upcoming league gets the same preview row the rest of
              the site uses; a finished one gets the results card instead —
              here, and only here, Completed is a different card, because what
              you came back for is where YOU placed, not who won. */}
          {list.map((g) =>
            isCompleted(g) ? (
              <CompletedLeagueTile key={g.id} game={g} />
            ) : (
              <div
                key={g.id}
                className="rounded-2xl border border-gray-200 bg-white px-4 md:px-5"
              >
                <PublicLeagueRow game={g} bleed={PANEL_BLEED.inset} member />
              </div>
            )
          )}
        </div>
      ) : (
        // No footer action here on purpose: the page's own "Create a League"
        // CTA sits a scroll above this card, so a second one would just repeat
        // it. Public Leagues keeps its footer — that one creates a different
        // kind of league.
        <LeagueEmptyState
          art={<EmptyStateArt variant="myLeagues" />}
          title="No leagues yet"
          body="Your first one is one tap away."
        />
      )}
    </section>
  );
};

export default MyLeaguesSection;
